import * as React from "react";
function FastTrackIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px",
    "data-rtl-flip": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.897 1.175 7.826 11.25v-.856l-7.826 11.25a.75.75 0 0 0 1.232.856l7.826-11.25a.75.75 0 0 0 0-.856L14.129.319a.75.75 0 0 0-1.232.856M3.318-.003c-1.143 0-1.69 1.043-1.035 1.98l6.708 9.642a.76.76 0 0 1-.02.78l-6.687 9.617c-.653.94-.107 1.978 1.036 1.978h3.3a2.87 2.87 0 0 0 2.126-1.086l6.737-9.68c.48-.764.48-1.698.02-2.433L8.774 1.122a2.87 2.87 0 0 0-2.11-1.12L3.319-.004zm0 1.5L6.62 1.5c.348.02.708.208.949.514l6.681 9.608a.75.75 0 0 1-.02.78l-6.69 9.614c-.214.27-.574.458-.963.48l-3.258-.002c.066 0 .235.321.196.378l6.707-9.647c.48-.765.48-1.697.02-2.431l-6.73-9.675c.04.057-.127.378-.195.378z"
  }));
}
export default FastTrackIcon;